import React from 'react';
import { arrayOf, bool, shape, func } from 'prop-types';
import { Table } from 'antd';
import './style.less';

function PathwayStagesTable({ columns, dataSource, loading, onChange }) {
  return (
    <Table
      bordered
      className="pathway-stages-table"
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      pagination={false}
      rowKey={record => record.id || record.key}
      scroll={{ x: true }}
      onChange={onChange}
    />
  );
}

PathwayStagesTable.propTypes = {
  columns: arrayOf(shape({})),
  dataSource: arrayOf(shape({})),
  loading: bool,
  onChange: func,
};

PathwayStagesTable.defaultProps = {
  columns: [],
  dataSource: [],
  loading: false,
  onChange: () => {},
};

export default PathwayStagesTable;
